import(/* webpackMode: "eager" */ "/home/developer/workspace/nextjs-ship/node_modules/leaflet/dist/leaflet.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/workspace/nextjs-ship/src/components/GlobalFaviconSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/workspace/nextjs-ship/src/components/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/home/developer/workspace/nextjs-ship/src/styles/tailwind.css");
